<template>
  <div class="relay-placeholder">
    <RelayDetail :relay="FAKE_RELAY" />
    <div class="relay-placeholder__overlay"></div>
    <div class="relay-placeholder__animation"></div>
  </div>
</template>

<script>
import RelayDetail from './RelayDetail.vue';

const FAKE_RELAY = {
  address1: '46 Rue Barrouin',
  address2: [],
  address3: [],
  city: 'Saint-Étienne',
  name: 'Le Gobelet Français',
  zipcode: '42000',
  opening_hours_items: {},
  distance: 1000,
};

export default {
  name: 'RelayPlaceholder',
  components: { RelayDetail },
  data() {
    return {
      FAKE_RELAY,
    };
  },
};
</script>
